export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ08.4ed4ae14.mp3";